import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { IMultiEnabled } from '../../interfaces';
import { sortTextArrayByDict, subscribersFeaturesDict, upperCaseFirstLetter } from '../../instruments';
import Styles from '../styles/m_itemCardStyles.less';

type IMultiTadigShowField = {
    children?: never;
    values?: IMultiEnabled;
};

export const MultiFeaturesShowTags: React.FC<IMultiTadigShowField> = ({ values = {} }: IMultiTadigShowField) => {
    const names: Array<string> = sortTextArrayByDict(Object.keys(values), subscribersFeaturesDict);

    return (
        <span className={Styles.tadigBox}>
            {names.map((item: string) => {
                const text = upperCaseFirstLetter(item);
                const isOn = values?.[item].enabled;
                return (
                    <Tooltip key={item} title={`${upperCaseFirstLetter(item)}: ${isOn ? 'On' : 'Off'}`}>
                        <Tag
                            icon={isOn ? <CheckOutlined /> : <CloseOutlined />}
                            className={cx(
                                Styles.tadig,
                                values?.[item].enabled ? Styles.tadigEnable : Styles.tadigDisable,
                            )}
                        >
                            {text}
                        </Tag>
                    </Tooltip>
                );
            })}
        </span>
    );
};
